import { useState } from 'react';
import { useFormikContext, Field } from 'formik';

import { InputUI, TabsUI, FormLabelUI, FormErrorUI } from '../../../Interface';
import ConformityComponent from './ConformityComponent';

const DescriptionPanel = (props) => {
  const { disabled } = props;
  const { values, errors } = useFormikContext();
  return (
    <div className="col-span-full relative">
      <div>
        <Field
          type="text"
          name="comment"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Megjegyzés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.comment} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.comment !== '' }}
          multiline
          rows={4}
        />
      </div>
    </div>
  );
};

const ConformityTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Komponensek',
      content: <ConformityComponent {...props} />,
    },
    {
      id: 1,
      name: 'Megjegyzés',
      content: <DescriptionPanel {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default ConformityTabs;
